import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Zap } from 'lucide-react';
import { Button } from './ui/button';

const ConciergeLauncher = () => {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate('/ask')}
      className="fixed bottom-6 right-6 z-40 flex items-center gap-3 px-5 py-3 rounded-full shadow-lg"
      style={{
        backgroundColor: 'hsl(var(--primary))',
        color: 'hsl(var(--primary-foreground))',
        boxShadow: 'var(--shadow-lg)'
      }}
    >
      <div className="flex items-center justify-center w-5 h-5">
        <Zap className="w-4 h-4" fill="currentColor" />
      </div>
      <div className="hidden sm:flex flex-col items-start">
        <span className="text-sm font-semibold">Ask Grid Guide</span>
        <span className="text-xs opacity-90">Find anything, instantly</span>
      </div>
    </button>
  );
};

export default ConciergeLauncher;
